// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.externalComm-div-padding {
  padding-left: 17px;
  padding-right: 15px;
}

.primary {
  margin-left: 5px;
}

.secondary {
  margin-left: 5px;
}

.sendLetterButtonPadding {
  padding-bottom: 15px;
  padding-right: 15px;
}

.sendLetterForm {
  max-width: 99.5%;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
